<template>
    <div>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="11">
                            <v-card-title class="titulopagina">REPORTE  DESPACHOS  DE  HARINA</v-card-title>
                        </v-col>
                        <v-col cols="1">
                            <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                                <v-icon color="blue" large>help</v-icon>
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <modal-ayuda></modal-ayuda>
            <v-card>
                <v-row class="ml-1 mr-1">
                    <v-col  cols="1">
                    </v-col>
                    <v-col  cols="4"><!-- 
                        <v-select
                        class="float-left"
                        :items="tipos_busqueda"
                        item-text='texto'
                        item-value='id'
                        label="Buscar por"
                        dense
                        ></v-select> -->
                        <v-radio-group v-model="tipo" row class="float-left">
                            <v-radio label="Por Guía" value="1"></v-radio>
                            <v-radio label="Por Lote" value="2"></v-radio>
                        </v-radio-group>
                        <v-text-field
                            @input="buscar"
                            dense
                            class="float-left ml-2"
                            label="Busqueda"
                            v-model="busqueda"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn class="float-right" color="green darken-1" dark small @click="descargarExcel" :disabled="url==''">Excel</v-btn>
                    </v-col>
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="3">
                        <!-- <date-picker v-model="fecha" placeholder ="Seleccione Fecha" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD" class="float-right mr-1"></date-picker> -->
                        <date-picker class="float-right" v-model="fechas" range-separator="|" range placeholder ="Seleccione Rango de Fechas" format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="1">
                        <v-btn class="float-right" color="green darken-1" @click="cargarDespachos" dark small><v-icon>refresh</v-icon></v-btn>
                    </v-col>
                </v-row>
                
            </v-card>

             <v-alert type="info" v-show="despachos.length == 0" class="mt-3 ml-1 mr-1">
                No Se Encontraron Despachos
            </v-alert>

            <!--<v-row class="ml-1 mr-1" v-if="despachos.length > 0">
                    <v-col>
                        <v-card>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th colspan="5">
                                            BODEGA
                                        </th>
                                        <th colspan="4">
                                            ROMANA
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Turno</th>
                                        <th>Patente</th>
                                        <th>Cantidad Maxisacos</th>
                                        <th>Kilos</th>
                                        <th>Fecha Salida</th>
                                        <th>Ticket</th>
                                        <th>Guía</th>
                                        <th>Peso Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="d in despachos" :key="d.id">
                                        <td :rowspan="d.tickets.length">
                                            {{d.fecha | formatearFecha}}
                                        </td>
                                        <td :rowspan="d.tickets.length">
                                            {{d.turno.nombre_turno}}
                                        </td>
                                        <td :rowspan="d.tickets.length">
                                            {{d.patente}}
                                        </td>
                                        <td :rowspan="d.tickets.length">
                                            {{d.cantidad_jumbos}}
                                        </td>
                                        <td :rowspan="d.tickets.length">
                                            {{d.peso_jumbos}}
                                        </td>
                                        <td colspan="4">
                                                <tr v-for="t in d.tickets" :key="t.ticket">
                                                    <td>{{t.fecha_ticket | fechaCompleta}}</td>
                                                    <td>{{t.ticket}}</td>
                                                    <td>{{t.guia}}</td>
                                                    <td>{{t.cantidad_despacho}}</td>

                                                </tr>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card>
                    </v-col>
            </v-row>-->


            <v-row v-for="d in despachos" :key="d.id">
                <v-col>
                    <v-card>
                        <v-row class="ml-1 mr-1">
                            <v-col>
                                <v-card>
                                    <v-simple-table dense>
                                        <thead >
                                            <tr class="bodega">
                                            <th class="text-center" colspan="5">
                                                BODEGA
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="text-center">Fecha</th>
                                            <th class="text-center">Turno</th>
                                            <th class="text-center">Patente</th>
                                            <th class="text-center">Cantidad Maxisacos</th>
                                            <th class="text-center">Kilos</th>
                                        </tr>
                                        </thead>
                                        
                                        <tbody>
                                            <tr>
                                                <td class="text-center">{{d.fecha | formatearFecha}}</td>
                                                <td class="text-center">{{d.turno?d.turno.nombre_turno:''}}</td>
                                                <td class="text-center">{{d.patente}}</td>
                                                <td class="text-center">{{d.cantidad_jumbos}}</td>
                                                <td class="text-center">{{d.peso_jumbos}}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-card>

                                <v-card>
                                    <v-simple-table dense>
                                        <thead >
                                            <tr class="bodega">
                                            <th class="text-center" colspan="5">
                                                DETALLE MAXISACOS
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="text-center">LOTE</th>
                                            <th class="text-center">MAXISACOS N°</th>
                                            <th class="text-center">BARRIDOS</th>
                                        </tr>
                                        </thead>
                                        
                                        <tbody>
                                            <tr v-for="(lote,idx) in d.lotes" :key="idx">
                                                <td class="text-center">{{lote.nombre_lote}}</td>
                                                <td class="text-center">{{lote.maxisacos}}</td>
                                                <td class="text-center">{{lote.barridos}}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-card>
                                
                            </v-col>
                            <v-col>
                                <v-card>
                                    <v-simple-table dense>
                                        <thead>
                                            <tr class="romana">
                                                <th class="text-center" colspan="4">
                                                    ROMANA
                                                </th>
                                            </tr>
                                            <tr>
                                                <th class="text-center">Fecha-Hora Salida</th>
                                                <th class="text-center">Ticket</th>
                                                <th class="text-center">Guía</th>
                                                <th class="text-center">Peso Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="t in d.tickets" :key="t.ticket">
                                                <td class="text-center">{{t.fecha_ticket | fechaCompleta}}</td>
                                                <td class="text-center">{{t.ticket}}</td>
                                                <td class="text-center">{{t.guia}}</td>
                                                <td class="text-center">{{t.cantidad_despacho}}</td>
                                            </tr>
                                        </tbody>
                                        
                                    </v-simple-table>
                                </v-card>
                                
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                
                
            </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        fecha:'',
        fechas:null,
        despachos:[],
        tipos_busqueda:[{id:1,texto:'Guía'},{id:2,texto:'Lote'}],
        tipo:'1',
        busqueda:'',
        url:''
    }),
    mounted() {
        this.fechas = this.moment().format('YYYY-MM-DD');
        this.cargarDespachos();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte Despachos de Harina`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un listado de los despachos de un lote o guía indicados asociados con su respectivo despacho de Romana. Se puede hacer la búsqueda por lote o guía y por un rango de fechas. Además de poder exportar toda la información a Excel.`},
                {   tipo:`label`,   texto:`- Para hacer la búsqueda de los despachos, se indica la Guía o Lote según corresponde y, al pulsar Enter, se realizará la búsqueda (además se puede agregar un rango de fechas).`},
                {   tipo:`label`,   texto:`- Se mostrarán distintas tablas indicando el despacho generado en el sistema y a qué despachos generados en el sistema de Romana están asociados. Además de un detalle con las fecha, turno, patente del camión, cantidad de maxisacos y un detalle de los maxisacos en el caso del despacho generado en sistema de Producción y fecha de salida, ticket, guía y peso total en el caso del despacho asociado generado en sistema de Romana.`},
                {   tipo:`label`,   texto:`- Al pulsar el botón "Excel", se exportará toda la información mostrada según los filtros indicados en formato Excel.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarDespachos(){
            //this.mostrarLoading('Cargando Despachos...');
            this.mostrarLoading({titulo:'Cargando Despachos...',color:'green'})

            let url = `${this.base_url}despachos_harina/${this.fechas[0]}/${this.fechas[1]}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('despachos',res.data);
                this.despachos = res.data.data;
                this.url = res.data.url;
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },

        async buscar(){
            let url = `${this.base_url}despachos_harina/tipo/${this.tipo}/${this.busqueda}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('resultado',res.data);
                this.despachos = res.data.data
                this.url = res.data.url;
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
            });
        },

        descargarExcel(){
            window.open(
              this.url, "_blank");
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .bodega{
        background-color: #BBDEFB;
    }
    .romana{
        background-color: #A5D6A7;
    }
</style>